<template>
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
  >
    <path d="M7.73171 14.7948C8.03264 15.0795 8.50733 15.0662 8.79196 14.7653C9.07658 14.4644 9.06336 13.9897 8.76243 13.7051L3.52339 8.74995H16.2471C16.6613 8.74995 16.9971 8.41416 16.9971 7.99995C16.9971 7.58574 16.6613 7.24995 16.2471 7.24995H3.52112L8.76243 2.29269C9.06336 2.00807 9.07658 1.53338 8.79196 1.23245C8.50733 0.931511 8.03264 0.91829 7.73171 1.20291L1.31449 7.27236C1.14819 7.42964 1.04819 7.62975 1.01448 7.83854C1.00308 7.89053 0.99707 7.94454 0.99707 7.99995C0.99707 8.05754 1.00356 8.11362 1.01585 8.16749C1.05084 8.37328 1.15039 8.57019 1.31449 8.7254L7.73171 14.7948Z" />
  </svg>
</template>
